import { defineAsyncComponent } from 'vue'

export const initModelDefinitionsEditor = () => {
  $core.VueClass.component(
    'ModelColumnDefinitionEditor',
    defineAsyncComponent(() => import('./components/ModelColumnDefinitionEditor.vue')),
  )
}
